import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/forms')({
  beforeLoad: ({ location }) => {
    if (location.pathname.replace(/\/+$/, '') === '/dashboard/forms') {
      throw redirect({ to: '/dashboard/settings/appointment-forms', replace: true });
    }
  },
  component: FormsLayout,
});

function FormsLayout() {
  return <Outlet />;
}
